import { Shadows } from '@mui/material/styles';
import { ThemeMode } from './palette';

/**
 * A soft, two-layer shadow ramp tinted with the surface ink instead of MUI's
 * default hard gray. Subtle in light mode (Stripe/Linear feel), a touch deeper in
 * dark mode where surfaces need more separation. 25 entries (MUI requirement).
 */
export const createShadows = (mode: ThemeMode): Shadows => {
  const rgb = mode === 'light' ? '28, 27, 24' : '0, 0, 0';
  const intensity = mode === 'light' ? 1 : 1.5;

  const shadows: string[] = ['none'];

  for (let i = 1; i <= 24; i += 1) {
    const y = Math.round(i * 1.1) + 1;
    const blur = Math.round(i * 2 + 4);
    const spread = Math.round(i * 0.2);
    const a1 = Math.min(0.5, (0.04 + i * 0.0045) * intensity);
    const a2 = Math.min(0.5, (0.03 + i * 0.0025) * intensity);

    shadows.push(
      `0px ${y}px ${blur}px ${spread}px rgba(${rgb}, ${a1.toFixed(3)}), ` +
        `0px ${Math.round(y / 2)}px ${Math.round(blur / 2)}px rgba(${rgb}, ${a2.toFixed(3)})`
    );
  }

  return shadows as unknown as Shadows;
};
